/* eslint-disable @typescript-eslint/ban-types */
import {configureStore} from '@reduxjs/toolkit';
import 'cross-fetch/polyfill';
import {userApi} from './api/userApi';
import {storesApi} from './api/storesApi';
import {designsApi} from './api/designsApi';
import {productsApi} from './api/productsApi';
import * as user from './slices/userSlice';
import * as stores from './slices/storesSlice';
import * as app from './slices/appSlice';
import errorMiddleware from './middleware/errorMiddleware';
import {mergeDeep} from './utils/helpers';

export const store = configureStore({
  reducer: {
    user: user.reducer,
    stores: stores.reducer,
    app: app.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [storesApi.reducerPath]: storesApi.reducer,
    [designsApi.reducerPath]: designsApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      userApi.middleware,
      storesApi.middleware,
      designsApi.middleware,
      productsApi.middleware,
      errorMiddleware
    )
});

export const initialState = store.getState();
export const createPreloadedStore = (
  preloadedState: PreloadedStateType
): StoreType =>
  configureStore({
    // Configure store must be called with a config directly to have middleware typing
    reducer: {
      user: user.reducer,
      stores: stores.reducer,
      app: app.reducer,
      [userApi.reducerPath]: userApi.reducer,
      [storesApi.reducerPath]: storesApi.reducer,
      [designsApi.reducerPath]: designsApi.reducer,
      [productsApi.reducerPath]: productsApi.reducer
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(
        userApi.middleware,
        storesApi.middleware,
        designsApi.middleware,
        productsApi.middleware,
        errorMiddleware
      ),
    preloadedState: mergeDeep(initialState, preloadedState)
  });

type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;
export type StoreType = typeof store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type PreloadedStateType = DeepPartial<RootState>;
